import PRODUCT_TYPE from "../const/productType";
var getDrawerHeaderTitle = function (type) {
    switch (type) {
        case PRODUCT_TYPE.INSTALLMENT_LOAN_SECURED:
        case PRODUCT_TYPE.INSTALLMENT_LOAN_PAY_IN_FOUR:
        case PRODUCT_TYPE.INSTALLMENT_LOAN:
        case PRODUCT_TYPE.INSTALLMENT_LOAN_MONTHLY:
            return "drawerHeader.subtitle.loan";
        case PRODUCT_TYPE.DUAL_CARD:
        case PRODUCT_TYPE.LIMITED_USE_DUAL_CARD:
        case PRODUCT_TYPE.BUSINESS_RETAIL_CARD:
        case PRODUCT_TYPE.PRIVATE_LABEL:
            return "drawerHeader.subtitle.account";
        default:
            return "drawerHeader.subtitle.account";
    }
};
export default getDrawerHeaderTitle;
//# sourceMappingURL=getDrawerHeaderTitle.js.map